import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

// GET ALL TERM AND CONDITION LOCATION
export const getAllTermAndconditionLocation = createAsyncThunk(
  'TermAndConditionSlice/getAllTermAndconditionLocation',
  async (params, thunkAPI) => {
    const { page = 1, limit = 10 } = params;

    try {
      const response = await axiosInstance.get(`/term-conditions?page=${page}&limit=${limit}&reference_type=location`);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

// GET ALL TERM AND CONDITION LOCATION
export const getAllTermAndconditionService = createAsyncThunk(
  'TermAndConditionSlice/getAllTermAndconditionService',
  async (params, thunkAPI) => {
    const { page = 1, limit = 10 } = params;

    try {
      const response = await axiosInstance.get(
        `/term-conditions?page=${page}&limit=${limit}&reference_type=sub_service`,
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

// GET TERM AND CONDITION BY ID
export const getTermAndConditionById = createAsyncThunk(
  'TermAndConditionSlice/getTermAndConditionById',
  async (id, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`/term-conditions/${id}`);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

// CREATE TERM AND CONDITION LOCATION
export const createTermAndConditionLocation = createAsyncThunk(
  'TermAndConditionSlice/createTermAndConditionLocation',
  async (payload, thunkAPI) => {
    try {
      const response = await axiosInstance.post(`/term-conditions`, { ...payload });

      thunkAPI.dispatch(getAllTermAndconditionLocation({ page: 1, limit: 10 }));

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

// CREATE TERM AND CONDITION LOCATION
export const createTermAndConditionService = createAsyncThunk(
  'TermAndConditionSlice/createTermAndConditionService',
  async (payload, thunkAPI) => {
    try {
      const response = await axiosInstance.post(`/term-conditions`, { ...payload });

      thunkAPI.dispatch(getAllTermAndconditionLocation({ page: 1, limit: 10 }));

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

// DELETE TERM AND CONDITION
export const deleteTermAndCondition = createAsyncThunk(
  'TermAndConditionSlice/deleteTermAndCondition',
  async (id, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(`/term-conditions/${id}`);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

// UPDATE TERM AND CONDITION
export const updateTermAndCondition = createAsyncThunk(
  'TermAndConditionSlice/updateTermAndCondition',
  async (payload, thunkAPI) => {
    const { payloadData, tacId } = payload;

    try {
      const response = await axiosInstance.put(
        `/term-conditions/${tacId}`,
        { ...payloadData },
        {
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
          },
        },
      );

      const data = await response.data;
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);
